import { Directive } from '@angular/core';

@Directive({
  selector: '[appTableFilterRowDef]',
})
export class TableFilterRowDefDirective {
  constructor() { }
}
